import React from "react";
import { Link } from "gatsby";
import { OutboundLink } from "gatsby-plugin-google-gtag";

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-brand">
        <Link className="footer-logo" to="/">
          Gerrymandering Project
        </Link>
        <p>
          Nonpartisan analysis, maps, and resources for fair representation
          through redistricting reform.
        </p>
        <Link className="footer-state-cta" to="/reforms">
          Browse all states <span aria-hidden="true">→</span>
        </Link>
      </div>

      <nav className="footer-navigation" aria-label="Footer">
        <div className="footer-column">
          <h3>Explore</h3>
          <ul>
            <li>
              <Link to="/redistricting-report-card">
                Redistricting Report Card
              </Link>
            </li>
            <li>
              <Link to="/reforms">Browse All States</Link>
            </li>
            <li>
              <Link to="/redistricting-timeline-alert-map">
                Redistricting Timeline Alert
              </Link>
            </li>
            <li>
              <Link to="/tests">Gerrymandering Tests</Link>
            </li>
          </ul>
        </div>

        <div className="footer-column">
          <h3>About</h3>
          <ul>
            <li>
              <Link to="/about">About the Project</Link>
            </li>
            <li>
              <Link to="/resources">Resources</Link>
            </li>
            <li>
              <Link to="/data-code">Data &amp; Code</Link>
            </li>
            <li>
              <Link to="/scholarly-work">Scholarly Work</Link>
            </li>
          </ul>
        </div>

        <div className="footer-column">
          <h3>Connect</h3>
          <ul>
            <li>
              <OutboundLink
                target="_blank"
                rel="noopener noreferrer"
                href="https://docs.google.com/forms/d/e/1FAIpQLScx9z7g6Kd7wkTYNtsD59XmxFN6ZdRpVa2bQx2UR6XrZiQmJA/viewform?usp=sf_link"
              >
                Submit Feedback
              </OutboundLink>
            </li>
            <li>
              <OutboundLink
                target="_blank"
                rel="noopener noreferrer"
                href="https://samwang.substack.com"
              >
                Fixing Bugs in Democracy
              </OutboundLink>
            </li>
            <li>
              <OutboundLink
                target="_blank"
                rel="noopener noreferrer"
                href="https://election.princeton.edu"
              >
                Princeton Election Consortium
              </OutboundLink>
            </li>
            <li>
              <OutboundLink
                target="_blank"
                rel="noopener noreferrer"
                href="https://representable.org"
              >
                Representable
              </OutboundLink>
            </li>
            <li>
              <OutboundLink
                target="_blank"
                rel="noopener noreferrer"
                href="https://twitter.com/princetongerry"
              >
                Twitter
              </OutboundLink>
            </li>
          </ul>
        </div>
      </nav>
    </footer>
  );
};

export default Footer;
